import { useMemo, useState } from 'react';
import { BookOpen, CaretDown, CaretUp, MagnifyingGlass } from '@phosphor-icons/react';
import { GLOSSAIRE_PUBLIC } from '../../lib/glossairePublic';

/**
 * RP72 (MOA-A10) — glossaire intégré à « Mon chantier » : les mots du chantier en
 * français courant (registre public de 09-VOCABULAIRE). Replié par défaut.
 */
export default function Glossaire({ defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const [q, setQ] = useState('');

  const entrees = useMemo(() => {
    const n = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    const cle = n(q.trim());
    if (!cle) return GLOSSAIRE_PUBLIC;
    return GLOSSAIRE_PUBLIC.filter(e => n(`${e.terme} ${e.aussi} ${e.definition}`).includes(cle));
  }, [q]);

  return (
    <section className="border border-[#E0E0DB] bg-white" data-testid="glossaire">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full px-4 py-3 flex items-center gap-2 text-left"
        aria-expanded={open}
        data-testid="glossaire-toggle"
      >
        <BookOpen size={18} className="text-[#1E3A5F]" />
        <span className="flex-1 text-sm font-bold text-[#2C2C2C]">Les mots du chantier</span>
        {open ? <CaretUp size={16} /> : <CaretDown size={16} />}
      </button>
      {open && (
        <div className="border-t border-[#E0E0DB] px-4 py-3 space-y-3">
          <label className="flex items-center gap-2 border border-[#E0E0DB] px-3 py-2">
            <MagnifyingGlass size={16} className="text-[#9A9A9A]" />
            <input
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder="Chercher un mot (avenant, réserve…)"
              className="flex-1 text-sm outline-none bg-transparent"
              data-testid="glossaire-recherche"
            />
          </label>
          <dl className="divide-y divide-[#F0F0EC]">
            {entrees.map(e => (
              <div key={e.terme} className="py-2">
                <dt className="text-sm font-semibold text-[#2C2C2C]">{e.terme}</dt>
                {e.aussi && <dd className="text-xs text-[#9A9A9A]">Aussi écrit : {e.aussi}</dd>}
                <dd className="text-sm text-[#4A4A4A] mt-0.5">{e.definition}</dd>
              </div>
            ))}
            {entrees.length === 0 && <p className="text-sm text-[#9A9A9A] py-2">Aucun mot ne correspond.</p>}
          </dl>
        </div>
      )}
    </section>
  );
}
